import { Link } from "react-router-dom";
import { categories } from "@/lib/media";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                91视频网站
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              专注热门影视资源聚合与发现，覆盖电影、电视剧、综艺全品类，帮你在海量内容里快速找到想看的片子。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link
                    to={category.path}
                    className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">快捷入口</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  搜索影视
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" aria-hidden="true"></i>
                support@91video.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-base text-accent-400" aria-hidden="true"></i>
                在线时间：每日 09:00 - 21:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6">
          <p className="text-xs leading-relaxed text-background-200/60">
            免责声明：本站为影视内容展示与技术演示站点，站内所有影视作品名称、简介及图片均为虚构示例，仅用于界面演示，不提供任何在线播放或下载功能。
          </p>
          <div className="mt-4 flex flex-col gap-2 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 91视频网站 · 保留所有权利</span>
            <span>内容仅供演示 · 请支持正版影视</span>
          </div>
        </div>
      </div>
    </footer>
  );
}